import PDFPage from './PDFPage';

export default PDFPage;
